// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { Chapter, Module, ModuleType } from '../../../../../../../types/Model';
import { useCourseType, useCurrentModule } from '../../../../../hooks';
import LabModule from './LabModule';
import VodModule from './VodModule';
import ChallengeModule from './ChallengeModule';
import ExamModule from './ExamModule';
import HyperlinkModule from './HyperlinkModule';
import AssessmentModule from './AssessmentModule';
import TextModule from './TextModule';
interface ModulesProps {
  courseId: number;
  chapters: Chapter[];
  chapterIndex: number;
}

const Modules: React.FC<ModulesProps> = (props):JSX.Element => {
  const {
    courseId,
    chapters,
    chapterIndex,
  } = props;
  const modules = chapters[chapterIndex].modules;
  const currentModule = useCurrentModule(chapters);
  const type = useCourseType();

  const renderModule = (module:Module, moduleIndex:number) => {
    const active = currentModule === module;
    switch (module.type) {
      case ModuleType.VIDEO:
        return (
          <VodModule
            key={moduleIndex}
            active={active}
            to={`/${type}/${courseId}/contents?chapter=${chapterIndex + 1}&module=${moduleIndex + 1}`} module={module}
          />
        )
      case ModuleType.CHALLENGE:
        return (
          <ChallengeModule
            key={moduleIndex}
            active={active}
            to={`/${type}/${courseId}/contents?chapter=${chapterIndex + 1}&module=${moduleIndex + 1}`} module={module}
          />
        )
      case ModuleType.LAB:
        return (
          <LabModule
            key={moduleIndex}
            active={active}
            to={`/${type}/${courseId}/contents?chapter=${chapterIndex + 1}&module=${moduleIndex + 1}`} module={module}
          />
        )
      case ModuleType.EXAM:
        return (
          <ExamModule
            key={moduleIndex}
            active={active}
            to={`/${type}/${courseId}/contents?chapter=${chapterIndex + 1}&module=${moduleIndex + 1}`} module={module}
          />
        )
      case ModuleType.HYPERLINK:
        return (
          <HyperlinkModule
            key={moduleIndex}
            active={active}
            to={`/${type}/${courseId}/contents?chapter=${chapterIndex + 1}&module=${moduleIndex + 1}`} module={module}
          />
        )
      case ModuleType.TEXT:
        return (
          <TextModule
            key={moduleIndex}
            active={active}
            to={`/${type}/${courseId}/contents?chapter=${chapterIndex + 1}&module=${moduleIndex + 1}`} module={module}
          />
        )
      case ModuleType.QUIZ:
        return (
          <>QUIZ [Todo]</>
        )
      case ModuleType.ASSESSMENT:
        return (
          <AssessmentModule
            key={moduleIndex}
            active={active}
            to={`/${type}/${courseId}/contents?chapter=${chapterIndex + 1}&module=${moduleIndex + 1}`} module={module}
          />
        )
      default:
        return null;
    }
  }

  return (
    <>
      {modules.map((module, moduleIndex) => renderModule(module, moduleIndex))}
    </>
  );
}

export { Modules as default };
